var map = {
	"./IMG-logo.png": 860,
	"./allianz-logo.png": 57,
	"./berkley-logo.png": 861,
	"./blueCross-logo.png": 71,
	"./canada-life-logo.png": 862,
	"./carewell-logo.png": 501,
	"./desjardins-logo.png": 863,
	"./gms-logo.png": 92,
	"./ia-logo.png": 864,
	"./img-logo2.png": 189,
	"./manulife-logo.png": 865,
	"./rbc-logo.png": 866,
	"./stonewell_logo_KO.png": 867,
	"./stonewell_logo_blk.png": 868,
	"./stonewell_logo_blk_white.png": 869,
	"./stonewell_logo_col.png": 870,
	"./sunlife-logo.png": 871,
	"./travelance-logo.png": 64,
	"./trawick-logo.png": 872,
	"./tugo-logo.png": 53,
	"./worldtrip-logo.png": 873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 859;